module.exports = __webpack_public_path__ + "static/media/iconupload.470fb81e.svg";